import React from 'react';
import { motion } from 'framer-motion';
import fullImage from '../assets/rider.png';

const VideoSection = () => {
  return (
    <motion.section
      initial={{ opacity: 0, y: 60, scale: 0.95 }}
      whileInView={{ opacity: 1, y: 0, scale: 1 }}
      transition={{ duration: 1.2 }}
      viewport={{ once: false, amount: 0.3 }}
      className="w-full overflow-hidden px-4 py-8 flex justify-center sm:px-6 sm:py-10 md:px-8 md:py-12 lg:px-10 lg:py-16 xl:px-12 xl:py-20"
      style={{ fontFamily: 'Helvetica, Arial, sans-serif' }}
    >
      <img
        src={fullImage}
        alt="Therapy demonstration"
        className="w-auto h-auto max-w-full object-contain rounded-md"
      />
    </motion.section>
  );
};

export default VideoSection;
